import type { ActionModel } from '@jet/environment/types/models';

export interface ContextualMenuDeleteFromLibraryAction extends ActionModel {
    $kind: 'contextualMenuDeleteFromLibraryAction';
    type: 'confirm-delete';
    title: string;
    text: string;
    cancelButton: { title: string; action: unknown };
    deleteButton: { title: string; action: unknown };
}

export function makeContextualMenuDeleteFromLibraryAction(
    attributes: any,
): ContextualMenuDeleteFromLibraryAction {
    return {
        $kind: 'contextualMenuDeleteFromLibraryAction',
        type: 'confirm-delete',
        ...attributes,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}
